import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import SetAlertButton from '../../Input/ButtonWithChildren/SetAlertButton/SetAlertButton';
import './SetAlertCallToAction.scss';

export default class SetAlertCallToAction extends React.PureComponent {
    static propTypes = {
        /*Job Information*/
        jobSearches: PropTypes.object.isRequired,
        /**
         * Whether Or Not It is active*
         * */
        active: PropTypes.bool,
        /**
         * onclick function
         * */
        onClick: PropTypes.func.isRequired,
    };

    render() {
        const jobTitle = this.props.jobSearches.jobSearchTerm || null;
        const jobLocation = this.props.jobSearches.jobLocation || null;
        const jobText = `${jobTitle} in ${jobLocation}`;
        return (
            <div className="component-CallToAction-SetAlertCallToAction">
                <div className="message">
                    {truncateWithEllipsis(jobText, 100)}
                </div>
                <SetAlertButton
                    onClick={this.props.onClick}
                    active={this.props.active}
                />
            </div>
        );
    }
}
